<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [accordionHeading]="tablesTranslations.i18nMembership"
         [isPanelOpened]="isPanelOpened"
         [actionButtonTooltip]="tooltipTranslations.i18nCreateNewMembership"
         [actionButtons]="actionButtons"

         [emptyStateIcon]="'#esf-icon-users'"
         [emptyStateText]="tablesTranslations.i18nNoMembership"
         [emptyStateButtonText]="tablesTranslations.i18nAddNewMembership"

         (actionButtonClickEvent)="authenticatedUser.canAddMembership ? createMembership() : null"
         (rowClickEvent)="authenticatedUser.canAddMembership ? editMembership($event) : null"
         (rowButtonClickEvent)="authenticatedUser.canDeleteMembership ? deleteMembershipModal($event) : null"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened)"

         [data]="currentMembership"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>
